import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Core components
import Select from 'components/core/Select';
// Custom
import { DisabledContext } from 'components/misc/Contexts';

const BaseListFilter = ({ field: selectedField, searchFields, onChange }) => (
  <DisabledContext.Consumer>
    {(disabled) => (
      <Select
        disabled={disabled}
        label={<LocalizedMessage id="field.searchBy" />}
        value={selectedField}
        items={_map(searchFields, ({ key, labelId, field }) => ({ key, labelId, value: field }))}
        onChange={onChange}
      />
    )}
  </DisabledContext.Consumer>
);

BaseListFilter.propTypes = {
  field: PropTypes.string.isRequired,
  searchFields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
      labelId: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

module.exports = BaseListFilter;



// WEBPACK FOOTER //
// ./components/filters/BaseListFilter.js